module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA7klEQVR4AWOgC2iad1XMawODxQrCCAL+f9/3+e2+pNYznParidPw++3/fx/+//9/6e43u4x9TJYrCWmAg9+3/v//uWrvY+XgLYQ0/P3+782cv49L/r3o+v/jCFCgcc4VQdf1ODX8+3ru7/2EP+f5/1xR//d61v+/n/7///Pu5c641pO4NJz9+yD+z3k+uAaQ4IuNz/LKzwmqwRGqk17P/vu4+N+Lzv8/jwEFXvRMv6RsDlaHQJievg10yYfNu6+auEFU4NDw+93/fyA3fL/56LZv3DlhDaAcPg3/vu7/+3bPw/z6C1J6EAmcGgYlAADhLPu+AdrotgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PH.png
// module id = 1240
// module chunks = 0